import { CONTACTS_ENUM } from "Constants/contacts";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";

const Headerdetails = ({ order, rightToLeft }: any) => {
  const { t } = useTranslation(['common', 'pdfOrder','myOrder']);

  const supplierCustomer =
  typeof order?.supplier_customer === "object" &&
  order.supplier_customer?.id
    ? order.supplier_customer
    : null;
const isIncomingSupplierOrder = Boolean(order?.prior_order);

const customer = isIncomingSupplierOrder
  ? order?.business || {}
  : supplierCustomer || order?.business || {};

  
const primaryContact =
  customer?.contacts?.find((contact: any) => contact.is_primary) ||
  customer?.contacts?.[0] ||
  null;

const buildAddress = (...parts: any[]) =>
  parts
    .filter((part) => {
      if (part === undefined || part === null) {
        return false;
      }

      const value = String(part).trim().toLowerCase();

      return (
        value !== "" &&
        value !== "undefined" &&
        value !== "null"
      );
    })
    .map((part) => String(part).trim())
    .join(", ");

const customerPhone =
  customer?.phone ||
  primaryContact?.phone ||
  "";

const customerEmail =
  customer?.email ||
  customer?.mail ||
  primaryContact?.email ||
  "";

const customerAddress = buildAddress(
  customer?.address,
  customer?.city,
);

const supplierSite = !isIncomingSupplierOrder && typeof order?.supplier_customer_site === "object"
  ? order.supplier_customer_site : null;
const project = supplierSite ? {
  ...supplierSite,
  project_address_line1: supplierSite.address,
  project_city: supplierSite.city,
  contacts: [{ role: CONTACTS_ENUM.SITE_MANAGER,
    full_name: supplierSite.site_manager_name, phone: supplierSite.phone }],
} : order?.project;

const siteAddress = buildAddress(
  project?.project_address_line1,
  project?.project_city,
);

  return (
    <>
      <div className="bussiness-details">
        <div className="item">
          <p className="label">{t('phone office', {ns: 'pdfOrder'})}:</p>
         <p className="val">{customerPhone}</p>
        </div>
        <div className="item">
          <p className="label">{t('mail', {ns: 'pdfOrder'})}:</p>
          <p className="val text-lowercase">{customerEmail}</p>
        </div>
        <div className="item">
          <p className="label">{t('address', {ns: 'pdfOrder'})}:</p>
          <p className="val">{customerAddress}</p>
        </div>
        <div className="item">
          <p className="label">{t('document creater', {ns: 'pdfOrder'})}:</p>
          <p className="val">
            {order.created_by &&
              (`${order.created_by.first_name} ${order.created_by.last_name}` || "")}{" "}
            {order.created_by && (order.created_by.phone || "")}
          </p>
        </div>
      </div>
      <div className="divider" style={{ margin: "0 40px" }}></div>
      <p style={{ margin: "0 40px" }}>{t('delivery details', {ns: 'pdfOrder'})}:</p>
      <div className="divider-gray" style={{ margin: "0 40px" }}></div>
      <div className="bussiness-details">
        <div className="item">
          <p className="label">{t('delivery date request', {ns: 'pdfOrder'})}:</p>
          <p className="val-date">
            {order.delivery_date &&
              format(new Date(order.delivery_date), "dd/MM/yyy")}
          </p>
        </div>
        <div className="item">
          <p className="label">{t('site address', {ns: 'pdfOrder'})}:</p>
          <p className="val">{siteAddress}</p>
        </div>
        <div className="item">
          <p className="label">{t('site manager', {ns: 'myOrder'})}</p>
          <p className="val">
            {project?.contacts &&
              <>
                {project?.contacts.find(
                  (item: any) => item.role === CONTACTS_ENUM.SITE_MANAGER
                ) &&
                  project?.contacts.find(
                    (item: any) => item.role === CONTACTS_ENUM.SITE_MANAGER
                  ).full_name}{" "}
                {project?.contacts.find(
                  (item: any) => item.role === CONTACTS_ENUM.SITE_MANAGER
                ) &&
                  project?.contacts.find(
                    (item: any) => item.role === CONTACTS_ENUM.SITE_MANAGER
                  ).phone}
              </>
            }
          </p>
        </div>
        <div className="item">
          <p className="label">{t('site man two', {ns: 'pdfOrder'})}</p>
          <p className="val">
          {project?.contacts &&
              <>
                {project?.contacts.find(
                  (item: any) => item.role === CONTACTS_ENUM.SITE_MAN
                ) &&
                  project?.contacts.find(
                    (item: any) => item.role === CONTACTS_ENUM.SITE_MAN
                  ).full_name}{" "}
                {project?.contacts.find(
                  (item: any) => item.role === CONTACTS_ENUM.SITE_MAN
                ) &&
                  project?.contacts.find(
                    (item: any) => item.role === CONTACTS_ENUM.SITE_MAN
                  ).phone}
              </>
}
          </p>
        </div>
      </div>
      <div className="divider-gray" style={{ margin: "0 40px" }}></div>
      <p style={{ margin: "5px 40px" }}>{t('arrival notes', {ns: 'pdfOrder'})}: {project?.driver_notes}</p>
      <div className="divider" style={{ margin: "0 40px" }}></div>
      {order.order_notes &&
        <>
          <p style={{ margin: "5px 40px" }}>{t('order notes', {ns: 'pdfOrder'})}: {order.order_notes}</p>
          <div className="divider" style={{ margin: "0 40px" }}></div>
        </>
      }
      {order.supplier_edited && (
        <div className="supplier-edited-pdf-notice">
          <p>
            {t("order edited by supplier", {
              ns: "pdfOrder",
            })}
          </p>
        </div>
      )}
      <div className="names">
        <div className="item">
          <p className={"label " + (rightToLeft ? "item__ml":"item__mr")}>{t("order name", { ns: "pdfOrder" })}:</p>
          <p className="val">{order?.name}</p>
        </div>
        <div className="item">
          <p className={"label " + (rightToLeft ? "item__ml":"item__mr")}>{t("project name", { ns: "pdfOrder" })}:</p>
          <p className="val">{project?.name}</p>
        </div>
      </div>
      <div className="divider" style={{ margin: "0 40px" }}></div>
    </>
  );
};

export default Headerdetails;
